import React, { useState, useEffect } from 'react';
import { PhoneInput, defaultCountries } from 'react-international-phone';
import { PhoneNumberUtil } from 'google-libphonenumber';
import 'react-international-phone/style.css';
import { useTranslation } from 'react-i18next';

// Component code
const PhoneInputField = ({ formik }) => {
  const { t } = useTranslation('common');

  const [touched, setTouched] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const validatePhone = (phone) => {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (formik.values.phone_number) {
      setIsValid(validatePhone(formik.values.phone_number));
    }
  }, [formik.values.phone_number]);

  return (
    <>
      <div className={`${touched && formik.errors.phone_number ? 'is-invalid' : ''}`}>
        <PhoneInput
          defaultCountry="ma"
          preferredCountries={['ma']}
          countries={defaultCountries}
          placeholder="+212 6 69 60 42 09"
          value={formik.values.phone_number}
          onChange={(value) => {
            formik.setFieldValue('phone_number', value);
          }}
          onBlur={() => {
            setTouched(true);
            formik.setFieldTouched('phone_number', true);
          }}
          inputStyle={{
            width: '100%',
            height: 'calc(1.5em + 0.75rem + 8px)',
            padding: '0.575rem 1.125rem',
            fontSize: '1rem',
            lineHeight: 1.5,
            color: '#404956',
            borderEndEndRadius: '0.5rem',
            borderStartEndRadius: '0.5rem',
            borderColor: touched && !isValid ? '#dc3545' : '#cfd4dc'
          }}
          countrySelectorStyleProps={{
            buttonClassName: 'px-4',
            buttonStyle: {
                height: 'calc(1.5em + 0.75rem + 8px)',
                padding: '0.575rem 1.125rem',
                fontSize: '1rem',
                lineHeight: 1.5,
                color: '#404956',
                borderStartStartRadius: '0.5rem',
                borderEndStartRadius: '0.5rem',
                borderColor: touched && !isValid ? '#dc3545' : '#cfd4dc'
            }
          }}
          
          
        />
      </div>
      {touched && formik.errors.phone_number && (
        <div className="invalid-feedback d-block">
          {t(formik.errors.phone_number)}
        </div>
      )}
    </>
  );
};

export default PhoneInputField;
